module.exports = __webpack_public_path__ + "img/home_index.ceea3a41.png";